var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2216_4629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.588 3.3999H15.412C16.9795 3.3999 18.25 4.6704 18.25 6.2379V12.9534C18.25 14.5209 16.9795 15.7914 15.412 15.7914H11.5592L10.2557 18.0437C10.1402 18.2499 9.835 18.2499 9.7195 18.0437L8.416 15.7914H4.588C3.0205 15.7914 1.75 14.5209 1.75 12.9534V6.2379C1.75 4.6704 3.0205 3.3999 4.588 3.3999ZM5.58622 11.4684C5.27272 11.4684 4.98397 11.3364 4.75297 11.1136V11.3859H3.82072V7.27739H4.75297V8.58089C4.98397 8.35814 5.26447 8.22614 5.58622 8.22614C6.44422 8.22614 7.14547 8.95214 7.14547 9.85139C7.14547 10.7506 6.44422 11.4684 5.58622 11.4684ZM8.65522 11.3859H7.71472V8.68814C7.71472 8.23439 7.46722 8.01989 7.21147 8.01164V7.17839C7.83847 7.21964 8.65522 7.63213 8.65522 8.67989V11.3859ZM10.8085 11.4684C9.90921 11.4684 9.18322 10.7424 9.18322 9.84314C9.18322 8.94389 9.90921 8.21789 10.8085 8.21789C11.7077 8.21789 12.4337 8.94389 12.4337 9.84314C12.4337 10.7424 11.7077 11.4684 10.8085 11.4684ZM16.171 11.1549C16.171 12.4089 15.214 12.6811 14.554 12.7059V11.8809C15.148 11.8479 15.28 11.5591 15.2717 11.0394V10.9816C15.0407 11.2126 14.7437 11.3529 14.4137 11.3529C13.5557 11.3529 12.8545 10.6516 12.8545 9.79364C12.8545 8.93564 13.5557 8.23439 14.4137 8.23439C14.7437 8.23439 15.0407 8.37464 15.2717 8.60564V8.32514H16.171V11.1549ZM15.3212 9.78537C15.3212 10.2061 14.9665 10.5526 14.5292 10.5526C14.092 10.5526 13.7372 10.2061 13.7372 9.78537C13.7372 9.36462 14.092 9.01812 14.5292 9.01812C14.9665 9.01812 15.3212 9.36462 15.3212 9.78537ZM6.27925 9.85137C6.27925 10.2886 5.9245 10.6516 5.479 10.6516C5.0335 10.6516 4.67875 10.2969 4.67875 9.85137C4.67875 9.40587 5.0335 9.05112 5.479 9.05112C5.9245 9.05112 6.27925 9.40587 6.27925 9.85137ZM11.5757 9.85137C11.5757 10.2721 11.2292 10.6186 10.8085 10.6186C10.3877 10.6186 10.0412 10.2721 10.0412 9.85137C10.0412 9.43062 10.3877 9.08412 10.8085 9.08412C11.2292 9.08412 11.5757 9.43062 11.5757 9.85137Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2216_4629)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.7ada33505c7a22bd07ddf77bbd4c1430.svg";
export { ForwardRef as ReactComponent };